BrowserService = ->
  isSupportLocalStorage: ->
    testKey = 'localStorageTest'
    try
      localStorage.setItem(testKey, testKey)
      localStorage.removeItem(testKey)
      return true
    catch error
      return false

  isSupportCookie: ->
    #http://www.sveinbjorn.org/cookiecheck
    cookieEnabled = if navigator.cookieEnabled then true else false
    if typeof navigator.cookieEnabled == 'undefined' and !cookieEnabled
      document.cookie = 'testcookie'
      cookieEnabled = if document.cookie.indexOf('testcookie') != -1 then true else false
    cookieEnabled


module.exports = BrowserService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/browser/browser-service.coffee